import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { unMaskInputValue } from 'utils/helpers';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

export const useDisplayUtils = () => {
  const { t } = useTranslation();
  const { boardStatusValues } = useCroptimizer();

  const getTextOfTotal = useMemo(() => {
    const { currentPh, targetPh } = boardStatusValues || {};

    if (!currentPh || !targetPh) {
      return '';
    }

    const phraseStart = currentPh < targetPh ? t('forPhIncreasing') : t('from');

    return ` ${phraseStart} ${unMaskInputValue(currentPh)} ${t(
      'to',
    )} ${unMaskInputValue(targetPh)}`;
  }, [boardStatusValues, t]);

  return {
    getTextOfTotal,
  };
}; 